import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    let dataset = this.element.dataset;
    let dropdownParent = !!dataset.dropdownParent ? document.querySelector(dataset.dropdownParent) : this.element.parentElement,
      multiple = !!dataset.multiple ? dataset.multiple == 'true' : false,
      tags = !!dataset.tags ? dataset.tags == 'true' : false;

    let selectedValues = dataset.selectedValue;

    try {
      selectedValues = JSON.parse(dataset.selectedValue);
    } catch(e) {}

    $(this.element).select2({
      escapeMarkup: (markup) => markup,
      dropdownParent: dropdownParent,
      multiple: multiple,
      tags: tags,
    })
      .val(selectedValues)
      .trigger('change');
  }
};